import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { PackageSetupComponent } from './package-setup/package-setup.component';
import { IssuePackageComponent } from './issue-package/issue-package.component';
import { StockInformationComponent } from './stock-information/stock-information.component';
import { BookRequestComponent } from './book-request/book-request.component';
import { RequestApprovalAuthorityComponent } from './request-approval-authority/request-approval-authority.component';
import { BookRequestIssueComponent } from './book-request-issue/book-request-issue.component';
import { StationarySellReportComponent } from './stationary-sell-report/stationary-sell-report.component';
import { IssueItemDayWiseReportComponent } from './issue-item-day-wise-report/issue-item-day-wise-report.component';
import { PackagePrintComponent } from './package-print/package-print.component';
import { IssueItemPrintComponent } from './issue-item-print/issue-item-print.component';



const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'onetimepackagesetup', component: PackageSetupComponent, pathMatch: 'full' },
      { path: 'issueonetimepackage', component: IssuePackageComponent, pathMatch: 'full' },
      { path: 'stockinformation', component: StockInformationComponent, pathMatch: 'full' },
      { path: 'bookrequest', component: BookRequestComponent, pathMatch: 'full' },
      { path: 'bookrequestapprovalauthority', component: RequestApprovalAuthorityComponent, pathMatch: 'full' },
      { path: 'bookrequestissue', component: BookRequestIssueComponent, pathMatch: 'full' },
      { path: 'stationarysellreport', component: StationarySellReportComponent, pathMatch: 'full' },
      { path: 'issueitemdaywisereport', component: IssueItemDayWiseReportComponent, pathMatch: 'full' },


    ]
  },
  {
    path: '', children: [      
      { path: 'packageprint', component: PackagePrintComponent, pathMatch: 'full' },
      { path: 'issueitemprint', component: IssueItemPrintComponent, pathMatch: 'full' }
     
     
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookstoreRoutingModule { }
